//@ts-nocheck
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CfaService } from './cfa.service';
import Featurebase, {showNewMessage, showArticle, update, whenReady} from 'featurebase-js';
import { ToastNotificationService } from './toast-notification.service';
import { AuthService } from './auth.service';

@Injectable({providedIn: 'root'})
export class FeatureBaseService {
    constructor(
        private readonly _cfaService: CfaService,
        private readonly _toast: ToastNotificationService,
        private readonly _authService: AuthService
    ) {}

    async load() {
        try {
            whenReady(async () => {
                if (this._authService.user) {
                    const token = await this._cfaService.getFeatureBaseToken();
                    update({
                        appId: environment.featureBaseAppId,
                        featurebaseJwt: token
                    });
                }
            });
            Featurebase({
                appId: environment.featureBaseAppId
            });
        } catch (_) {}
    }

    hide() {
        if (!document.head.querySelector("#intercom-hide")) {
            const style = document.createElement("style");
            style.id = "featurebase-hide";
            style.innerHTML = `
                #fb-messenger-root {
                    display: none !important;
                }
            `;
            document.head.appendChild(style);
        }
    }

    show() {
        const style = document.head.querySelector("#featurebase-hide");
        if (style) {
            style.parentElement?.removeChild(style);
        }
    }

    open(msg?: string) {
        if (!this.loaded) {
            this._toast.show("Chat service is unavailable. Please send an email to hello@crewfiction.com", {duration: 10_000});
            return;
        }
        try {
            showNewMessage(msg);
        } catch (_) {
            this._toast.show("Chat service is unavailable. Please send an email to hello@crewfiction.com", {duration: 10_000});
        }
    }

    showArticle(articleId: number | string) {
        if (!this.loaded) {
            this._toast.show("Chat service is unavailable. Please send an email to hello@crewfiction.com", {duration: 10_000});
            return;
        }
        try {
            showArticle(articleId);
        } catch (_) {
            this._toast.show("Chat service is unavailable. Please send an email to hello@crewfiction.com", {duration: 10_000});
        }
    }
}